import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/styles.scss";

import BootstrapVue from "bootstrap-vue";
import { Plugin } from "vue-responsive-video-background-player";
import BackToTop from "vue-backtotop";
import VueYoutube from "vue-youtube";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronUp, faPhoneSquareAlt, faMoneyBillAlt, faShoppingCart, faTools, faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faChevronUp, faPhoneSquareAlt, faMoneyBillAlt, faShoppingCart, faTools, faBriefcase);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueYoutube);
Vue.use(BackToTop);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Plugin);
new Vue({
  data: {
    json: null,
  },
  router,
  // store,
  render: (h) => h(App),
}).$mount("#app");
